export enum SearchCategory {
  COMPANY = "COMPANY",
  LOCATION = "LOCATION",
  CONTACT = "CONTACT",
  CERTIFICATION = "CERTIFICATION",
}
